function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "36flfe6k8a"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "currentColor",
  floodOpacity: 1,
  result: "floodOut"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "floodOut",
  in2: "SourceGraphic",
  operator: "atop",
  result: "compOut"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "compOut",
  in2: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#36flfe6k8a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.278 5.734v9.549c0 2.761-2.225 5-4.969 5H5.696c-2.744 0-4.968-2.239-4.968-5V5.734c0-2.762 2.224-5 4.968-5h9.613c2.744 0 4.969 2.238 4.969 5zM5.696 2.373c-1.842 0-3.339 1.507-3.339 3.361v9.549c0 1.852 1.497 3.359 3.339 3.359h9.613c1.842 0 3.34-1.507 3.34-3.359V5.734c0-1.854-1.498-3.361-3.34-3.361H5.696zm9.696 6.883v5.593c0 .446-.358.805-.799.805-.441 0-.799-.359-.799-.805V9.256c0-.444.358-.804.799-.804.441 0 .799.36.799.804zm-4.089-2.081v7.674c0 .446-.359.805-.801.805-.44 0-.798-.359-.798-.805V7.175c0-.443.358-.803.798-.803.442 0 .801.36.801.803zm-4.091 5.169v2.505c0 .446-.357.805-.799.805-.442 0-.8-.359-.8-.805v-2.505c0-.445.358-.806.8-.806.442 0 .799.361.799.806z"
}));

var SvgTradingAnalysis = function SvgTradingAnalysis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTradingAnalysis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trading_analysis.794c19ff.svg";
export { ForwardRef as ReactComponent };